import { useEffect, useState } from "react";
import PlaySourceContent from "./PlaySourceContent";
import { AreaSource, PlayArea } from "../../PlayPanel.logic";

type Props = {
  playArea: PlayArea;
  areaInd: number;
  playMapInd: number;
};

const PlayAreaComponent = ({ playArea, areaInd, playMapInd }: Props) => {
  const [playInd, setPlayInd] = useState<number | null>(null);
  const [playActive, setPlayActive] = useState<boolean>(true);
  const [repeatPlayActive, setRepeatPlayActive] = useState<boolean>(false);

  useEffect(() => {
    if (playInd === null) {
      if (playActive && playArea.source.length > 0) {
        setPlayInd(0);
      }
    } else {
      if (playInd <= playArea.source.length - 2) {
        const durationMs = playArea.source[playInd].duration * 1000;
        setTimeout(() => {
          setPlayInd((currentPlayInd: number | null) =>
            currentPlayInd !== null ? currentPlayInd + 1 : null
          );
        }, durationMs);
      } else {
        const durationMs = playArea.source[playInd].duration * 1000;
        setTimeout(() => {
          setPlayInd(null);
          setPlayActive(false);
        }, durationMs);
      }
    }
  }, [playInd]);

  const elapseHandle = () => {
    // setPlayActive(false);
  };

  const timesCountElapseHandle = () => {
    console.log("timesCountElapseHandle");
    if (playInd !== null) {
      if (playInd < playArea.source.length - 1) {
        const nextPlayInd = playInd + 1;
        console.log("nextPlayInd", nextPlayInd);
        setPlayInd(nextPlayInd);
        setRepeatPlayActive(false);
      }
    }
  };

  return playActive && playInd !== null ? (
    <PlaySourceContent
      contentSource={playArea.source[playInd]}
      playMapInd={playMapInd}
      areaInd={areaInd}
      onElapse={elapseHandle}
    />
  ) : null;
};

export default PlayAreaComponent;
